import { useNavigate } from 'react-router-dom';
import './style.scss';

export default function CadastroObrigado() {
    const navigate = useNavigate();

    return (
        <div className="cadastro-obrigado">
            <div className="cadastro-obrigado__card">
                <div className="icon">🎉</div>

                <h1>Compra concluída com sucesso</h1>

                <p>
                    Agora você pertence à nossa comunidade <b>Istudo</b>.<br />
                    Entre na plataforma para acessar todas as nossas funcionalidades
                    e começar sua jornada de aprendizado.
                </p>

                <button
                    type="button"
                    className="btn btn--primary"
                    onClick={() => {
                        window.location.href = 'https://www.app.istudo.com';
                    }}
                >
                    Entrar na plataforma
                </button>


                <small className="muted">
                    Seja muito bem-vindo(a). Estamos felizes em ter você com a gente 💙
                </small>
            </div>
        </div>
    );
}
